

































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, maxLength, requiredIf } from 'vuelidate/lib/validators'
import WhiteSellerController, {
  WhiteSellerPayload,
} from '@/app/ui/controllers/WhiteSellerController'
import POSController from '@/app/ui/controllers/POSController'
import PODController from '@/app/ui/controllers/PODTrackerController'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import MarketplaceTextInput from '../../components/MarketplaceTextInput/index.vue'
import MarketplaceDropdown from '../../components/MarketplaceDropdown/index.vue'
import MarketplaceAddressSelect from '../../components/MarketplaceAddressSelect/index.vue'
import ModalConfirm from '../../components/MarketplaceModal/ModalConfirm.vue'
import ModalAlreadyRegister from '../../components/MarketplaceModal/ModalAlreadyRegister.vue'
import ModalSuccess from '../../components/MarketplaceModal/ModalSuccess.vue'
import ModalCourierNotFound from '../../components/MarketplaceModal/ModalCourierNotFound.vue'
import { POS } from '@/domain/entities/POS'
import {
  WhiteSellerCorporateClient,
  WhiteSellerPickupPoint,
} from '@/domain/entities/WhiteSeller'
import { LocalStorage, Utils } from '@/app/infrastructures/misc'
import { Courier } from '@/domain/entities/Courier'
import {
  MAX_NAME_WHITE_SELLER,
  MIN_NAME_WHITE_SELLER,
  MAX_TOTAL_PHONE_WHITE_SELLER,
} from '@/app/infrastructures/misc/Constants/validation'
import {
  CREATE_SELLER_ROLE_OPTIONS,
  COD_HANDLING_OPTIONS,
  EnumSellerRole,
  SellerRoleOption,
} from '@/app/infrastructures/misc/Constants/manageWhitelist'
import MarketplaceInputPhone from '../../components/MarketplaceInputPhone/index.vue'
import MarketplaceRadioButton from '../../components/MarketplaceRadioButton/index.vue'
import { PODTrackerDriver } from '@/domain/entities/PODTracker'

interface OptionsString {
  label: string
  value: string
}

interface OptionsNumber {
  label: string
  value: number
}

interface AddressOption {
  value: number
  name?: string
  picName?: string
  phoneNumber?: string
  address?: string
  latlon?: string
}

const CLIENT_SEARCH_DEBOUNCE_MS = 500

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    MarketplaceTextInput,
    MarketplaceDropdown,
    MarketplaceAddressSelect,
    ModalConfirm,
    ModalAlreadyRegister,
    ModalSuccess,
    ModalCourierNotFound,
    MarketplaceInputPhone,
    MarketplaceRadioButton
  },
})
export default class AddSellerWhitelist extends Vue {
  WhiteSellerController = WhiteSellerController
  POSController = POSController
  PODController = PODController
  modalCreateConfirm = false
  modalChangeRole = false
  modalAlreadyRegister = false
  modalSuccessAdd = false
  modalCRRNFD = false
  pendingRole: SellerRoleOption | null = null

  statusOptions = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]
  // Merchant is legacy-only and cannot be created
  sellerRoleOptions: SellerRoleOption[] = CREATE_SELLER_ROLE_OPTIONS
  codHandlingOptions = COD_HANDLING_OPTIONS
  partnerPOSOptions = <OptionsNumber[]>([])
  driverListOptions = <OptionsString[]>([])
  form = {
    sellerRole: null as SellerRoleOption | null,
    sellerName: '',
    sellerPhone: '',
    phoneCode: '+62',
    // Corporate only
    client: null as OptionsNumber | null,
    pcaIds: [] as number[],
    // Status defaults to "Tidak Aktif" (PRD)
    status: this.statusOptions[1],
    assignTo: 'pos',
    agentId: null as OptionsNumber | null,
    courierId: '' as any,
    assignType: '' as any,
    // CLIENT (Aggregator) only
    codHandling: null as OptionsString | null,
  }
  parameters = {
    page: 1,
    per_page: 100,
    search: '',
    sort_by: 'ASC',
    filter_status: 'ACTIVE'
  }
  courierParameters = {
    page: 1,
    per_page: 100,
    q: '',
    sort_by: 'ASC',
    courier_status: 'ACTIVE',
    driver_type: ''
  }
  MAX_NAME_WHITE_SELLER = MAX_NAME_WHITE_SELLER
  assignToOptions = [
    { label: 'POS', value: 'pos' },
    { label: 'Kurir', value: 'courier' }
  ]

  // Corporate lookups
  clientOptions = <OptionsNumber[]>[]
  clientKeyword = ''
  isLoadingClients = false
  isClientError = false
  clientRequestId = 0
  pickupPoints = <WhiteSellerPickupPoint[]>[]
  isLoadingPickupPoints = false
  isPickupPointError = false
  pickupRequestId = 0

  created(): void {
    POSController.getPOSData(this.parameters)
    PODController.getDriverList(this.courierParameters)
  }

  get myAccessMenus(): string[] {
    return JSON.parse(
      LocalStorage.getLocalStorage(LocalStorage.ACCESS_MENU, true)
    )
  }

  get roleValue(): string {
    return this.form.sellerRole?.value || ''
  }

  get isCorporate(): boolean {
    return this.roleValue === EnumSellerRole.COMPANY
  }

  get showCODHandlingDropdown(): boolean {
    return this.roleValue === EnumSellerRole.CLIENT
  }

  get showPartnerPos(): boolean {
    return this.form.assignTo === 'pos'
  }

  get isStatusActive(): boolean {
    return this.form.status?.value === 'ACTIVE'
  }

  get addressOptions(): AddressOption[] {
    const seen = new Set<number>()
    return this.pickupPoints.reduce((options, point) => {
      const id = Number(point.pcaId)
      if (id > 0 && !seen.has(id)) {
        seen.add(id)
        options.push({
          value: id,
          name: point.pcaName,
          picName: point.pcaPicName,
          phoneNumber: point.pcaPhoneNumber,
          address: point.pcaAddress,
          latlon: point.pcaLatlon,
        })
      }
      return options
    }, [] as AddressOption[])
  }

  get nameErrorMessage(): string {
    const length = this.form.sellerName.trim().length
    return length > 0 &&
      (length < MIN_NAME_WHITE_SELLER || length > MAX_NAME_WHITE_SELLER)
      ? `Nama harus ${MIN_NAME_WHITE_SELLER} sampai ${MAX_NAME_WHITE_SELLER} karakter`
      : ''
  }

  get phoneErrorMessage(): string {
    return this.form.sellerPhone && !this.isPhoneLengthValid()
      ? `Nomor telepon maksimal ${MAX_TOTAL_PHONE_WHITE_SELLER} karakter`
      : ''
  }

  // True when any role-dependent field has been filled in
  get hasDependentValue(): boolean {
    const { form } = this
    return Boolean(
      form.sellerName.trim() ||
        form.sellerPhone ||
        form.client ||
        form.pcaIds.length ||
        form.agentId ||
        form.courierId ||
        form.assignType ||
        form.codHandling
    )
  }

  private isPhoneLengthValid(): boolean {
    return (
      `${this.form.phoneCode}${this.form.sellerPhone}`.length <=
      MAX_TOTAL_PHONE_WHITE_SELLER
    )
  }

  // ---- Seller role -------------------------------------------------------

  private onSelectSellerRole(role: SellerRoleOption | null) {
    if (!role || role.value === this.form.sellerRole?.value) return

    // Dependent fields filled: keep current state until the user confirms
    if (this.form.sellerRole && this.hasDependentValue) {
      this.pendingRole = role
      this.modalChangeRole = true
      return
    }

    this.applySellerRole(role)
  }

  private onConfirmChangeRole() {
    const role = this.pendingRole
    this.onCancelChangeRole()
    if (role) this.applySellerRole(role)
  }

  private onCancelChangeRole() {
    this.pendingRole = null
    this.modalChangeRole = false
  }

  private applySellerRole(role: SellerRoleOption) {
    this.resetDependentFields()
    this.form.sellerRole = role
    if (role.value === EnumSellerRole.COMPANY) this.fetchClients('', true)
  }

  private resetDependentFields() {
    // invalidate any in-flight lookup so stale responses are ignored
    this.clientRequestId++
    this.pickupRequestId++

    this.form.sellerName = ''
    this.form.sellerPhone = ''
    this.form.client = null
    this.form.pcaIds = []
    this.form.agentId = null
    this.form.courierId = ''
    this.form.assignType = ''
    this.form.codHandling = null

    this.clientOptions = []
    this.clientKeyword = ''
    this.isLoadingClients = false
    this.isClientError = false
    this.pickupPoints = []
    this.isLoadingPickupPoints = false
    this.isPickupPointError = false
  }

  // ---- Corporate: client & address --------------------------------------

  private async fetchClients(keyword: string, force = false) {
    if (!force && keyword === this.clientKeyword) return

    const requestId = ++this.clientRequestId
    this.clientKeyword = keyword
    this.isLoadingClients = true
    this.isClientError = false

    try {
      const clients: WhiteSellerCorporateClient[] =
        (await WhiteSellerController.getCorporateClients(keyword)) || []
      if (requestId !== this.clientRequestId) return
      this.clientOptions = clients.map(client => ({
        label: `${client.clientCode}-${client.clientName}`,
        value: Number(client.clientId),
      }))
    } catch (error) {
      if (requestId !== this.clientRequestId) return
      this.clientOptions = []
      this.isClientError = true
    } finally {
      if (requestId === this.clientRequestId) this.isLoadingClients = false
    }
  }

  private onSearchClient = Utils.debounce((keyword: string) => {
    this.fetchClients(keyword || '')
  }, CLIENT_SEARCH_DEBOUNCE_MS)

  private onSelectClient(client: OptionsNumber | null) {
    this.form.client = client
    // client changed: drop old options & selection, ignore late responses
    this.pickupRequestId++
    this.form.pcaIds = []
    this.pickupPoints = []
    this.isPickupPointError = false
    this.isLoadingPickupPoints = false

    if (client) this.fetchPickupPoints(client.value)
  }

  private async fetchPickupPoints(clientId: number) {
    const requestId = ++this.pickupRequestId
    this.isLoadingPickupPoints = true
    this.isPickupPointError = false

    try {
      const points: WhiteSellerPickupPoint[] =
        (await WhiteSellerController.getCorporatePickupPoints(clientId)) || []
      if (requestId !== this.pickupRequestId) return
      this.pickupPoints = points
    } catch (error) {
      if (requestId !== this.pickupRequestId) return
      this.pickupPoints = []
      this.isPickupPointError = true
    } finally {
      if (requestId === this.pickupRequestId) this.isLoadingPickupPoints = false
    }
  }

  // ---- Assignment --------------------------------------------------------

  private onSearchPartnerPOS = Utils.debounce((keyword: string) => {
    const params = {
      ...this.parameters,
      search: keyword
    }
    POSController.getPOSData(params)
  }, 500)

  private onSelectPartnerPOS(pos: OptionsNumber) {
    if (pos) POSController.getCourierList(String(pos.value))
  }

  private handleNewCourier() {
    if (this.myAccessMenus && this.myAccessMenus.includes("manage-courier")) {
      let routeData = this.$router.resolve({ name: 'CreateManageCourierPage' })
      window.open(routeData.href, '_blank')
    } else {
      this.$notify({
        title: 'Forbidden Access',
        text: 'Please request access to admin',
        type: 'error',
        duration: 3000,
      })
      this.modalCRRNFD = false
    }
  }

  private onBackToList() {
    this.$router.push({ name: 'ManageWhitelist' })
  }

  private async onSubmit() {
    if (WhiteSellerController.isLoading || !this.form.sellerRole) return

    const created = await WhiteSellerController.create(this.buildPayload())

    // Failure keeps the form; only close the confirmation so the error
    // (shown by the controller) can be acted on.
    if (created === false) this.modalCreateConfirm = false
  }

  private buildPayload(): WhiteSellerPayload {
    const payload: WhiteSellerPayload = {
      sellerName: this.form.sellerName.trim(),
      status: this.form.status.value,
      sellerRole: this.roleValue,
    }

    if (this.isCorporate) {
      payload.clientId = this.form.client?.value
      payload.pcaIds = [...this.form.pcaIds]
    } else {
      payload.sellerPhone = `${this.form.phoneCode}${this.form.sellerPhone}`
      if (this.showCODHandlingDropdown) {
        payload.codHandling = this.form.codHandling?.value
      }
    }

    if (this.showPartnerPos) {
      if (this.form.agentId?.value) payload.agentId = [this.form.agentId.value]
    } else {
      payload.courierId = Number(this.form.courierId?.value || 0)
      payload.assignType = this.form.assignType?.value
    }

    return payload
  }

  private onPhoneCodeChange(phoneCode: string) {
    this.form.phoneCode = phoneCode
  }

  private onSearchDriverList = Utils.debounce((keyword: string) => {
    const params = {
      ...this.courierParameters,
      q: this.replacePhoneNumber(keyword || '')
    }
    this.PODController.getDriverList(params)
  }, 500)

  private replacePhoneNumber(text: string): string {
    if (/^08([0-9]+)$/.test(text)) {
      return Utils.countryIndonesiaPhoneNumber(text).trim()
    }

    return text
  }

  get assignTypeOptions(): OptionsString[] {
    const items = [
      { label: 'Offer', value: 'OFFER' },
      { label: 'Auto Assign', value: 'AUTO ASSIGN' }
    ]
    return items
  }

  private onChangeAssignTo() {
    this.form.courierId = ""
    this.form.assignType = ""
    this.form.agentId = null
  }

  @Validations()
  validations() {
    const isPosOrCourierRequired = this.isStatusActive
    const isAssignToPos = this.showPartnerPos
    const isCorporate = this.isCorporate
    const isPhoneLengthValid = () => this.isPhoneLengthValid()
    const hasMinNameLength = (value: string) =>
      value.trim().length >= MIN_NAME_WHITE_SELLER

    return {
      form: {
        sellerRole: { required },
        sellerName: {
          required,
          minLength: hasMinNameLength,
          maxLength: maxLength(MAX_NAME_WHITE_SELLER),
        },
        sellerPhone: {
          required: requiredIf(() => !isCorporate),
          maxLength: () => isCorporate || isPhoneLengthValid(),
        },
        client: { required: requiredIf(() => isCorporate) },
        // at least one pickup point (pca_id) for Corporate
        pcaIds: { required: requiredIf(() => isCorporate) },
        status: { required },
        agentId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && isAssignToPos
          })
        },
        courierId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
        assignType: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
      },
    }
  }

  @Watch('POSController.posData')
  setPOSPartner(data: POS[]): void {
    const POSOptions = data.map(item => {
      return {
        label: `${item.name} [${item.code}]`,
        value: item.id
      }
    }) as OptionsNumber[]
    this.partnerPOSOptions = POSOptions
  }

  @Watch('POSController.posCourier')
  setPOSCourier(data: Courier[]): void {
    if (data && data.length === 0) {
      this.form.agentId = null
      this.modalCRRNFD = true
    }
  }

  @Watch('WhiteSellerController.isAddWhiteSellerSuccess')
  setAddWhiteSellerSuccess(data: boolean): void {
    this.modalCreateConfirm = false
    this.modalSuccessAdd = data
    if (!data) this.modalAlreadyRegister = true
  }

  @Watch('form.sellerName')
  setSellerName(data: string): void {
    // remove script tag
    this.form.sellerName = Utils.removeScriptTags(data)

    // remove special character
    this.form.sellerName = Utils.removeSpecialCharacters(this.form.sellerName)

    // remove html tag
    this.form.sellerName = Utils.removeHTMLTags(this.form.sellerName)
  }

  @Watch('PODController.driverData')
  setDriverList(data: PODTrackerDriver[]): void {
    const DriverOption = data.map(item => {
      const label = `[${item.courierId}] ${item.fullname} (${item.announcementCourierType}) ${item.phoneNumber} • ${item.partnerName}`
      return {
        label,
        value: item.courierId?.toString()
      }
    }) as OptionsString[]
    this.driverListOptions = DriverOption
  }

  beforeDestroy(): void {
    WhiteSellerController.setIsAddWhiteSellerSuccess(false)
  }
}
